// Marketing site (WordPress) base URL.
//
// Resolution order:
//   1. REACT_APP_MARKETING_SITE_URL (preferred — set per environment via .env)
//   2. Default dev marketing site.
//
// Trailing slashes are stripped so callers can compose with `/path` safely.

const DEFAULT_MARKETING_SITE_URL = "https://dev.letsgetvisa.com";

const fromEnv = process.env.REACT_APP_MARKETING_SITE_URL?.trim();

const MARKETING_SITE_URL: string = (fromEnv || DEFAULT_MARKETING_SITE_URL).replace(/\/$/, "");

export default MARKETING_SITE_URL;
